import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['knob', 'input'];

  static classes = ['trackOn', 'trackOff', 'knobOn', 'knobOff'];

  toggle() {
    this.#setState(this.element.getAttribute('aria-checked') !== 'true');
  }

  #setState(checked) {
    this.element.setAttribute('aria-checked', String(checked));

    this.element.classList.remove(...(checked ? this.trackOffClasses : this.trackOnClasses));
    this.element.classList.add(...(checked ? this.trackOnClasses : this.trackOffClasses));

    this.knobTarget.classList.remove(...(checked ? this.knobOffClasses : this.knobOnClasses));
    this.knobTarget.classList.add(...(checked ? this.knobOnClasses : this.knobOffClasses));

    if (this.hasInputTarget) {
      this.inputTarget.value = String(checked);
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
